export default __webpack_public_path__ + "static/media/CL_BODY.91c9c8d8.pdf";